import { isRouteErrorResponse, useRouteError } from 'react-router';
import { t } from '@/shared/i18n';
import { dropOfflineCopy } from '@/shared/offline/dropCopy';
import { ErrorNotice } from '@/shared/ui/ErrorNotice';
import s from './rootError.module.css';

function reopen(): void {
  void dropOfflineCopy().then(() => {
    window.location.reload();
  });
}

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`;
  return error instanceof Error ? error.message : String(error);
}

/**
 * Вместо стандартного экрана «Unexpected Application Error» (правило Андрея, 03.11): ошибка раздела
 * говорит, что случилось и что делать. Висит на всех маршрутах, чтобы сбой одного раздела не ронял остальные.
 */
export function RouteError() {
  const error = useRouteError();
  console.error('Chat: ошибка раздела', error);
  return (
    <div className={s.page}>
      <ErrorNotice
        what={t('Раздел не открылся')}
        why={`${t('Не удалось загрузить или показать раздел:')} ${describe(error)}`}
        action={{ label: t('Открыть заново'), onClick: reopen }}
        avoid={t('Чаще всего так бывает, когда вышла новая версия Chat, а страница старая, или пропала сеть. Остальные разделы работают.')}
      />
    </div>
  );
}
